import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/MenuItem';

import Select from 'components/Select'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from 'selectors/common'
import { managers } from 'selectors/entities'

let select = dirtyRead(
	(state, props) => ({
		task: doc(state, props.objectID)
	  , managers: managers(state)
	})
)

export class ManagerSelect extends Component{
	render(){
		let { props } = this
		return(
			<Select
				value={(props.task && props.task.managerID) || 'unassign'}
				value={(props.task && props.task.managerID) || 'unassign'}
				hintText="Select manager"
				title="Please choose manager"
				icon= {
					<img
						src={".." + "/static/img/svg-icon/managers_green.svg"}
						style={{
							width: "16px"
						  , marginTop: "3px"
						  , marginLeft: "3px"
					}}/>
				}
				onChange={(evt, indx, value) =>{
					props.STAGE({
						_id: props.objectID
					  , managerID: (value == "unassign")? "" : value
					})
				}}
			>
				{
					[...R.map(manager => (
							<MenuItem key={manager._id} value={manager._id} primaryText={manager.name} />
						) ,R.values(R.filter((mgr) => !mgr.inactive, props.managers)))
					  , <MenuItem key="Unasigned" value="unassign" primaryText={<span style={{color: "#3cd2ae", borderBottom: "2px #3cd2ae dashed"}}>UNASSIGN</span>} />
					]
				}
			</Select>
		)
	}
}

export default connect(select, dataActions)(ManagerSelect)



// WEBPACK FOOTER //
// ./src/routes/manager/taskForm/ManagerSelect.js